import React, { useState, useRef, useEffect } from "react";
import "./styles.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useAuth0 } from "@auth0/auth0-react";
import { uploadFile, downloadFile } from "../../Auth/Presigned";
import { DateFormetContext } from "../../../app/App.js";
import { useSelector } from "react-redux";
import { CheckFloatValue } from "../../../utils/functions";
import thousands from "thousands";
import { toastr } from "react-redux-toastr";

function createData(date, chargesDetails, amount, amountPaid, amountDue) {
  return { date, chargesDetails, amount, amountPaid, amountDue };
}

const StatementDocument = ({
  data,
  downloadPDF,
  sharePDF,
  setFileData,
  setFile,
  setOpenTaxReport,
  setOpenTaxStatement,
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const { getAccessTokenSilently } = useAuth0();
  const LogoImage = useSelector((state) => state.homeReducer.headerLogo);
  const Image = localStorage?.getItem("Base64");

  let totalAmount = 0;
  const [loading, setLoading] = useState(false);
  for (let i = 0; i < data?.transaction.length; i++) {
    if (data?.transaction) {
      totalAmount += data?.transaction[i].total_amount;
    }
  }

  let totalAmountPaid = 0;
  for (let i = 0; i < data?.transaction.length; i++) {
    if (data?.transaction) {
      if (data?.transaction?.[i]?.total_paid) {
        if (data?.transaction?.[i]?.total_paid === null) totalAmountPaid += 0;
        else {
          totalAmountPaid += data?.transaction?.[i]?.total_paid;
        }
      } else {
        totalAmountPaid += 0;
      }
    }
  }

  let totalAmount_due = 0;
  for (let i = 0; i < data?.transaction.length; i++) {
    if (data?.transaction) {
      if (data?.transaction?.[i]?.amount_due) {
        if (data?.transaction?.[i]?.amount_due === null) totalAmount_due += 0;
        else {
          totalAmount_due += data?.transaction?.[i]?.amount_due;
        }
      } else {
        totalAmount_due += 0;
      }
    }
  }
  console.log("totalAmount_due", totalAmount_due);

  const inputRef = useRef(null);
  const printDocument = async () => {
    const token = await getAccessTokenSilently();
    if (downloadPDF) {
      const pdf = new jsPDF({
        orientation: "p",
        unit: "px",
        format: "a4",
        hotfixes: ["px_scaling"],
      });
      html2canvas(inputRef?.current, {
        width: pdf.internal.pageSize.getWidth(),
        height: pdf.internal.pageSize.getHeight() * 7,
      })
        .then(async (canvas) => {
          const imgData = canvas.toDataURL("image/png");

          pdf.addImage(
            imgData,
            "PNG",
            0,
            0,
            pdf.internal.pageSize.getWidth(),
            pdf.internal.pageSize.getHeight()
          );
          pdf.save("Statement.pdf");

          var out = pdf?.output("blob");
          setFileData([
            { name: "invoiceDoc", size: out?.size, type: out?.type },
          ]);
          setFile([imgData]);

          const convertedfile = new File([out], {
            type: "application/pdf",
            name: "invoiceDoc",
          });

          var splitedImgData = imgData.split(",")[1];
          var binary_string = window.atob(splitedImgData);
          var len = binary_string.length;
          var bytes = new Uint8Array(len);
          for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
          }
          if (imgData) {
            setLoading(true);
            let newURL = await uploadFile(bytes.buffer, convertedfile, token);

            let downloadLink = await downloadFile(newURL.fileName, token);
            let downloadURL = downloadLink.link;
            window.open(downloadURL, "_blank");
            setLoading(false);
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    } else if (sharePDF) {
      const pdf = new jsPDF({
        orientation: "p",
        unit: "px",
        format: "a4",
        hotfixes: ["px_scaling"],
      });
      html2canvas(inputRef?.current, {
        // scrollY: -window.scrollY,
        // scrollX: -window.scrollX,
        // width: pdf.internal.pageSize.getWidth(),
        height:
          data.transaction?.length < 10
            ? pdf.internal.pageSize.getHeight()
            : data.transaction?.length > 10 && data.transaction?.length <= 20
            ? pdf.internal.pageSize.getHeight() * 1.3
            : data.transaction?.length > 20 && data.transaction?.length <= 30
            ? pdf.internal.pageSize.getHeight() * 1.7
            : data.transaction?.length > 30 && data.transaction?.length <= 40
            ? pdf.internal.pageSize.getHeight() * 2
            : data.transaction?.length > 40 && data.transaction?.length <= 50
            ? pdf.internal.pageSize.getHeight() * 2.5
            : data.transaction?.length > 50 && data.transaction?.length <= 60
            ? pdf.internal.pageSize.getHeight() * 3
            : data.transaction?.length > 60 && data.transaction?.length <= 70
            ? pdf.internal.pageSize.getHeight() * 3.1
            : data.transaction?.length > 70 && data.transaction?.length <= 80
            ? pdf.internal.pageSize.getHeight() * 3.2
            : data.transaction?.length > 80 && data.transaction?.length <= 90
            ? pdf.internal.pageSize.getHeight() * 3.3
            : data.transaction?.length > 90 && data.transaction?.length <= 100
            ? pdf.internal.pageSize.getHeight() * 4
            : data.transaction?.length > 100 && data.transaction?.length <= 140
            ? pdf.internal.pageSize.getHeight() * 6
            : pdf.internal.pageSize.getHeight() * 7,
      })
        .then(async (canvas) => {
          const imgData = canvas.toDataURL("image/png");

          pdf.addImage(
            imgData,
            "PNG",
            0,
            0,
            pdf.internal.pageSize.getWidth(),
            pdf.internal.pageSize.getHeight()
          );

          var out = pdf?.output("blob");
          setFileData([
            { name: "invoiceDoc", size: out?.size, type: out?.type },
          ]);
          setFile([imgData]);

          const convertedfile = new File([out], {
            type: "application/pdf",
            name: "invoiceDoc",
          });

          var splitedImgData = imgData.split(",")[1];
          var binary_string = window.atob(splitedImgData);
          var len = binary_string.length;
          var bytes = new Uint8Array(len);
          for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
          }
          if (imgData) {
            setLoading(true);
            let newURL = await uploadFile(bytes.buffer, convertedfile, token);

            let downloadLink = await downloadFile(newURL.fileName, token);
            let downloadURL = downloadLink.link;
            window.location = `mailto:${
              data?.account_details?.email ?? ""
            }?subject=Statement ${
              data?.tax_id
            }&body= Here is the link to download document - ${encodeURIComponent(
              downloadURL
            )}`;
            setLoading(false);
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
  };
  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(num)
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  useEffect(() => {
    printDocument();
  }, []);

  let address = {};
  if (data?.account_details?.addresses) {
    for (var i = 0; i < data.account_details.addresses.length; i++) {
      if (data.account_details.addresses[i].billing) {
        address = {
          city: data.account_details.addresses[i].city,
          state: data.account_details.addresses[i].state,
          zip_code: data.account_details.addresses[i].zip_code,
          formattedAddress: `${
            data.account_details.addresses[i].location?.formattedAddress?.split(
              ","
            )[0]
          } ${
            data.account_details.addresses[i].addressLine2
              ? data.account_details.addresses[i].addressLine2
              : ""
          } `,
        };
      }
    }
  }
  return (
    <>
      {loading == true ? <p>Loading ...</p> : ""}
      <div
        className="pdf-doco p-10 d-flex flex-column justify-content-between"
        ref={inputRef}
      >
        {data ? (
          <>
            <div className="px-5">
              <div className="doco-head d-flex justify-content-between mb-10">
                <div className="doco-h-details">
                  <h1 className="font-16 font-weight-bolder">
                    {data.organization.orgName}
                  </h1>
                  <p className="font-14 m-0">
                    {data.organization.contactInfo.address}
                  </p>
                  <p>{data.organization.contactInfo.phone}</p>
                </div>
                <div className="doco-h-logo">
                  <img src={Image ?? LogoImage} width="200px" />
                </div>
              </div>

              <div className="doco-body mt-10">
                <div className="doco-body-h mb-10">
                  <div className="head d-flex justify-content-between">
                    <h1 className="font font-weight-bolder">
                      Statement {data?.tax_id}
                    </h1>
                    {/* <p>Tax ID {data?.tax_id}</p> */}
                  </div>
                  <div className="mt-5">
                    <div className="d-flex justify-content-between">
                      <p className="m-0">To: {data?.name} </p>
                      <p className="m-0">
                        {moment(data?.createdAt)
                          .utcOffset("+0100")
                          .format("LL")}
                      </p>
                    </div>
                    <div className="m-0">{address?.formattedAddress}</div>
                    <div className="m-0">
                      {address?.city}, {address?.state} {address?.zip_code}
                    </div>

                    {/* <div className="d-flex justify-content-between">
                      <p className="mt-2">
                        Balance: $ {thousands((+totalAmount_due).toFixed(2))}{" "}
                      </p>
                    </div> */}
                    <div>
                      <p className="m-0">
                        {data?.account_details?.admin_contact}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="my-5">
                  <p className="font-16 font-weight-bolder">
                    Outstanding balance: ${" "}
                    {thousands((+totalAmount_due).toFixed(2))} as of{" "}
                    {moment(data?.date.end).utcOffset("+0100").format("LL")}
                  </p>
                </div>

                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    className="table"
                  >
                    <TableHead className="doco-table-head">
                      <TableRow>
                        <TableCell className="table-head-text">
                          Transactions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tableBody">
                      <TableRow>
                        <TableCell className="tableBody-head-text">
                          Due Date
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          CHARGE DETAILS
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          TOTAL AMOUNT
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          TOTAL AMOUNT PAID
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          TOTAL AMOUNT DUE
                        </TableCell>
                      </TableRow>
                      {data?.transaction?.map((row, i) => (
                        <TableRow
                          key={i}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="tableBody-content"
                        >
                          <TableCell component="th" scope="row">
                            {moment(row.date)
                              .utcOffset("+0100")
                              .format(dateFormet)}
                          </TableCell>
                          <TableCell align="right">
                            {row.details?.Ledger?.name
                              ? row.details?.Ledger?.name
                              : ""}{" "}
                            <div style={{ "font-size": "11px" }}>
                              {row?.details?.SubLedger?.name
                                ? row?.details?.SubLedger?.name
                                : ""}
                            </div>
                            <div style={{ "font-size": "11px" }}>
                              {row?.visible ? row?.note : ""}
                            </div>
                          </TableCell>
                          <TableCell align="right">
                            {/* {getCommaSeperatedValue(row.total_amount)} */}${" "}
                            {thousands((+row.total_amount).toFixed(2))}
                          </TableCell>
                          <TableCell align="right">
                            {/* {getCommaSeperatedValue(row.total_paid)} */}${" "}
                            {row.total_paid
                              ? thousands((+row.total_paid).toFixed(2))
                              : "0.00"}
                          </TableCell>
                          <TableCell align="right">
                            {/* {getCommaSeperatedValue(row?.amount_due)} */}${" "}
                            {thousands((+row.amount_due).toFixed(2))}
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell className="tableBody-head-text">
                          TOTAL
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          {""}
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          {/* ${getCommaSeperatedValue(totalAmount)} */}${" "}
                          {thousands((+totalAmount).toFixed(2))}
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          {/* $ {getCommaSeperatedValue(totalAmountPaid)} */}${" "}
                          {thousands((+totalAmountPaid).toFixed(2))}
                        </TableCell>
                        <TableCell className="tableBody-head-text">
                          {/* $ {getCommaSeperatedValue(totalAmount_due)} */}${" "}
                          {thousands((+totalAmount_due).toFixed(2))}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div>
                {/* <p className="font-14 font-weight-bolder">PAY NOW</p> */}
                <p>
                  Phone
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  <a className="link">{data.organization.contactInfo.phone}</a>
                </p>
                <p>
                  Website &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  <a className="link">{data.organization.shul_website}</a>
                </p>
              </div>
              <div className="doco-footer d-flex justify-content-end pt-4">
                <p className="m-0">
                  Page 1 of 1 | Statement {data?.tax_id} | Created{" "}
                  {moment(data?.createdAt)
                    .utcOffset("+0100")
                    .format("LL h:mm A")}
                </p>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default StatementDocument;
